






import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class SelectedDays extends Vue {
  @Prop({ required: true }) readonly selectedDays!: string[];

  private formattedString = "";

  private readonly weekDays = [
    {
      name: "Lun",
      tag: "monday",
    },
    {
      name: "Mar",
      tag: "tuesday",
    },
    {
      name: "Mer",
      tag: "wednesday",
    },
    {
      name: "Gio",
      tag: "thursday",
    },
    {
      name: "Ven",
      tag: "friday",
    },
  ];

  private readonly weekends = [
    {
      name: "Sab",
      tag: "saturday",
    },
    {
      name: "Dom",
      tag: "sunday",
    },
  ];

  private readonly days = [...this.weekDays, ...this.weekends];

  @Watch("selectedDays")
  onDaysChange() {
    this.formattedString = "";
    this.formatString();
  }

  created() {
    this.formatString();
  }

  private formatString() {
    if (!this.selectedDays) {
      return;
    }

    if (this.continousDays) {
      this.formattedString = "Lun - Ven,";
      this.addWeekend();
    } else {
      this.notContinousDays();
    }

    this.formattedString = this.formattedString.substring(
      0,
      this.formattedString.length - 1
    );
  }

  get continousDays(): boolean {
    let continous = true;

    if (this.selectedDays.length < this.weekDays.length) {
      return false;
    }

    for (let i = 0; i < this.weekDays.length; i++) {
      const searchedDay = this.weekDays.find(
        (element) => element.tag === this.selectedDays[i]
      );

      if (searchedDay === undefined) {
        continous = false;
        break;
      }
    }

    return continous;
  }

  private notContinousDays() {
    this.selectedDays.forEach((day: string) => {
      const searchedDay = this.days.find((element) => element.tag === day);

      if (searchedDay !== undefined) {
        this.formattedString += " " + searchedDay?.name + ",";
      }
    });
  }

  private addWeekend() {
    this.selectedDays.forEach((day: string) => {
      const searchedDay = this.weekends.find((element) => element.tag === day);

      if (searchedDay !== undefined) {
        this.formattedString += " " + searchedDay?.name + ",";
      }
    });
  }
}
